$(document).ready(function() {

    // Default value to price_id
    var price_id = 1;
    // Initialise register page
    $('.child-select-wrapper').hide();

    /**
     * Tabs manager
     */

    $(".tabs-menu a").click(function(event) {
        event.preventDefault();
        $(this).parent().addClass("current");
        $(this).parent().siblings().removeClass("current");
        var tab = $(this).attr("href");
        $(".tab-content").not(tab).css("display", "none");
        $(tab).fadeIn();
    });
    $(".tabs-menu.current a").trigger("click");

    /**
     * AJAX setup
     */

    $.ajaxSetup({
        headers: {
            'X-CSRF-Token': $('meta[name="csrf_token"]').attr('content')
        }
    });

    /**
     * AJAX Requests
     */

    // Delete AJAX Request
    $(".delete-link").click(function(event){
        event.preventDefault();

        var path = $(this).attr('href');
        var confirm = $(this).data('confirm');

        if(!window.confirm(confirm)){
            return false;
        }

        $.ajax({
            'url': path,
            'method': 'DELETE'
        }).done(function(response, textStatus, jsXHR){
            location.reload();
        }).fail(function(jsXHR, textStatus, error){
            console.log(error);
        });
    });


    // Validate AJAX Request
    $(".validate-link").click(function(event){
        event.preventDefault();
        var path = $(this).attr('href');

        $.ajax({
            'url': path,
            'method': 'PUT'
        }).done(function(response, textStatus, jsXHR){
            location.reload();
        }).fail(function(jsXHR, textStatus, error){
            console.log(error);
        });
    });

    // Book for a lunch
    $('.table-calendar .checkable').click(function(){
        var current_date = $(this);
        var data_date = $(this).data('date');
        var data_student_id = $(this).data('student-id');
        var method = 'POST';

        if($(this).hasClass('checked')){
            method = 'DELETE';
        }

        console.log(method);
        $.ajax({
            'url': app.base_url + '/api/order/day',
            'method': method,
            'data': {
                'date': data_date,
                'student_id': data_student_id,
                'price_id': price_id,
            }
        }).done(function(response, textStatus, jsXHR){
            if(method == 'POST'){
                current_date.addClass('checked checked-'+price_id);
            }else{
                current_date.removeClass(function(){
                    return (this.className.match(/\b(checked checked-\d{1,3})\b/g) || []).join(' ');
                });
            }
        }).fail(function(jsXHR, textStatus, error){
            alert(jsXHR.responseJSON.error.message);
        });
    });

    // Book a full month
    $('.btn-order-month').click(function(){
        var data_date = $(this).data('date');
        var data_student_id = $(this).data('student-id');
        var method = 'POST';

        if($(this).hasClass('order-cancel')){
            method = 'DELETE';
        }

        $.ajax({
            'url': app.base_url+'/api/order/month',
            'method': method,
            'data' : {
                'date': data_date,
                'student_id': data_student_id,
                'price_id': price_id
            }
        }).done(function(response, textStatus, jsXHR){
            var month = data_date.split('-')[1];
            if(method == 'POST'){
                $('#month-'+month+' .checkable').addClass('checked checked-'+price_id);
            }else{
                $('#month-'+month+' .checkable').removeClass(function() {
                    return (this.className.match(/\b(checked checked-\d{1,3})\b/g) || []).join(' ');
                });
            }
        }).fail(function(jsXHR, textStatus, error){
            alert(jsXHR.responseJSON.error.message);
        });
    });

    // Select learners from classes
    $('.student-search').keyup(function(){
        var q = $(this).val();
        var student_search_results = $('.student-search-results');

        $.ajax({
            'url': app.base_url+'/api/students/search/html',
            'method': 'GET',
            'data': {
                'q': q,
            }
        }).done(function(response){
            student_search_results.empty();
            response.data.forEach(function (element) {
                var template = $('#student-card-template').html();
                Mustache.parse(template);
                var card = Mustache.render(template, element);
                student_search_results.append(card);
            });
            student_search_results.css('display', 'block');
        });
    });

    $('.student-search-results').on('click', '.student-card', function(e){
        if($('.selected-students-list').has('#'+$(this).attr('id')).length == 0){
            $('.selected-students-list').append($(this));
        }
    });

    $('.selected-students-list').on('click', '.student-card', function(){
        $(this).remove();
    });

    // Price switch
    $('.price-list .price-option').click(function(){
        $('.price-option').removeClass('current');
        price_id = $(this).attr('class').replace('price-option price-option-','');
        $(this).addClass('current');
        console.log(price_id);
    });
});
